import api from '@/services/api.js'
import endpointCalculator from '@/services/endpoint_calculator.js'

// Single sign-on across shops (ADR-0071). The SSO cookie lives on the API
// domain and is only sent on top-level navigations, so the login page goes
// to the API and comes back with a one-time code or with sso=none.

const endpoint = endpointCalculator()
const STATE_KEY = 'sso_state'

const queryString = (params) =>
  Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')

export const startUrl = (returnTo, state) =>
  `${endpoint}/v1/core/sso/start/?${queryString({
    return_to: returnTo,
    state,
  })}`

export const setUrl = (code, returnTo) =>
  `${endpoint}/v1/core/sso/set/?${queryString({ code, return_to: returnTo })}`

export const logoutUrl = (returnTo) =>
  `${endpoint}/v1/core/sso/logout/?${queryString({ return_to: returnTo })}`

const newState = () => {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

// What the login page does with its query: no SSO answer yet -> go to the
// API; a code with our state -> log in; anything else -> the form
export const resumeLogin = async ({ query, here, go }) => {
  const expected = sessionStorage.getItem(STATE_KEY)

  if (!query.sso && !query.sso_code) {
    const state = newState()
    sessionStorage.setItem(STATE_KEY, state)
    go(startUrl(here, state))
    return { action: 'redirect' }
  }

  sessionStorage.removeItem(STATE_KEY)
  // a code planted in the URL by another site has no matching state
  if (!query.sso_code || !expected || query.state !== expected) {
    return { action: 'form' }
  }

  try {
    const { data } = await api.ssoExchange(query.sso_code)
    if (data.token) return { action: 'login', data }
  } catch (err) {
    // the form still works without the SSO
  }

  return { action: 'form' }
}
